// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"3476104d3cf999e0346c","339":"a969ffccf3bf04e284aa"}[chunkId] + ".js";
};